module.exports = __webpack_public_path__ + "static/img/product_1_9.004915a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_1_9.png
// module id = ncjF
// module chunks = 34